import Keyb from "keyb"

import Stage from "@frog/source/models/Stage.js"
import Selection from "@frog/source/models/Selection.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Director from "@frog/source/juice/Director.js"
import Geometry from "@frog/source/utility/Geometry.js"

export default class CombatEncounter {
    constructor(encounter, party, game) {
        this.type = "combat"
    }
    static load(protoencounter) {
        const encounter = new CombatEncounter()
        encounter.type = "combat"
        encounter.player = protoencounter.player || {"affiliation": "good"}
        encounter.slug = protoencounter.slug
        encounter.images = protoencounter.images
        encounter.audio = protoencounter.audio
        if(encounter.audio != undefined) {
            Audiomix.trigger(encounter.audio)
        }
        // encounter.events = protoencounter.events

        // TODO: Let the protoencounter reference pre-existing encounters as well,
        // not just pre-existing encounter.stages.

        encounter.selection = new Selection({"encounter": encounter})

        encounter.stage = Stage.load(protoencounter.stage)
        // encounter.calculateActions(encounter.stage, true) // for some reason stage.hasCalculatedActions persists across reloads, pass true to always force on initial load

        // if(protoencounter.steps != undefined) {
        //     // TODO: support multiple protoactions, not just one.
        //     // const action = ActionMap.find(encounter.stage, protoencounter.protoactions[0])
        //     // TODO: find a better way to loop that allows cancelling.
        //     Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        //     // Director.add(protoencounter.steps) // THIS IS A SIDE EFFECT!!!
        // }

        // let that = encounter
        // for(let key in that) {
        //     this[key] = that[key]
        // }

        encounter.previousStages = []

        encounter.performNextTurn(encounter.stage) // BOMBER

        return encounter
    }
    update(delta) {
        this.selection.update(delta)

        // This is real dirty
        let stage = this.stage
        if(Director.steps[0] != undefined
        && Director.steps[0].stage != undefined) {
            stage = Director.steps[0].stage
        }

        if(Keyb.wasJustPressed("Z")) {
            this.undoAction()
        }
    }
    setStage(stage) {
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            this.stage = this.previousStages.pop()

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.frog != undefined
            && window.frog.test != undefined
            && window.frog.test.snapshot != undefined) {
                window.frog.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
                this.selection.reset()
            }
            this.selection.selectedSkillKey = undefined
        }
    }
    performAction(action) {
        const steps = action.steps
        Director.add(steps)

        // // Auto-finishing
        // if(Stage.hasFinishedTurn(this.player.affiliation, action.omegastage)) {
        //     // getNonPlayerSteps
        // }

        if(window.frog != undefined
        && window.frog.test != undefined
        && window.frog.test.snapshot != undefined) {
            window.frog.test.snapshot.protoactions.push({
                "unitKey": action.performerKey,
                "position": Geometry.copy(action.position),
                "actionKey": action.key,
            })
        }

        const omegastage = steps[steps.length-1].omegastage
        omegastage.steps = steps
        this.calculateActions(omegastage)
        this.setStage(omegastage)
        return omegastage
    }
    endPlayerTurn(stage) {
        if(Director.isPerforming == true) {
            return
        }
        stage = stage || this.stage

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()

        return this.performNextTurn(stage)
    }
    performNextTurn(stage) {
        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }

        const steps = stage.nextTurn.steps
        Director.add(steps)

        const omegastage = steps[steps.length-1].omegastage
        omegastage.steps = steps
        this.calculateActions(omegastage)
        this.setStage(omegastage)
        this.clearPreviousStages()
    }
    calculateActions(stage = this.stage, force = false) {
        return Stage.calculateActions(stage, force)
        // worker.call("Stage.calculateActions", stage).then((stage) => {
        //     // stage.units = units
        //     // stage.units = JSON.parse(units)
        //     this.setStage(stage)
        //     console.log(mark())
        //     // if(Director.isPerforming == false) {
        //     //     console.warn("Stage.calculateActions returned after Director.isPerforming")
        //     // }
        // })
    }
}
